<template>
  <div class="bidding_module">
    <div class="bidding_banner">
      <img src="../../../../static/img/bidding/enbidBnnaer.png" alt="" width="100%">
    </div>
    <div class="bidding_body">
      <div class="bidding_item">
        <el-row :gutter="20">
          <el-col :span="2">
            <div>
              <div class="bid_son_items bid_space">
                <div v-for="(bItem,index) in bidItemArr" :key="index" @click="bidModuleCtl(index)" class="bid_son_item" :class="{ activeType:activeIndex==index }">
                  <el-tooltip :content="bItem.name" placement="top-start" effect="light">
                    <!-- <span class="el-icon-s-home"></span> -->
                    <div>
                      <!-- <i class="iconfont icon-shouye"></i> -->
                      <i :class="bItem.icon" aria-hidden="true"></i>
                    </div>
                  </el-tooltip>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="22">
            <div>
              <div v-show="isNote" class="bid_space">
                <bid-note ref="bidNote" @sendBack="sendBack"></bid-note>
              </div>
              <div v-if="isForecast" class="bid_space">
                <bid-forcast ref="bidCast" @sendBack="sendBack"></bid-forcast>
              </div>
              <div v-show="isNews" class="bid_space">
                <bid-news ref="bidNews" @sendBack="sendBack"></bid-news>
              </div>
              <!-- <div v-show="isRecord" class="bid_space">
                <bid-record ref="bidRecord" @sendBack="sendBack"></bid-record>
              </div> -->
              <div v-show="isLaw">
                <bid-law ref="bidLaw" @sendBack="sendBack"></bid-law>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
import bidForcast from './bidForcast'; // 招标预告
import bidLaw from './bidLaw'; // 政策法规
import bidNews from './bidNews'; // 招标动态
import bidNote from './bidNote'; // 招标公告
export default {
  data() {
    return {
      isNote: true,
      isRecord: true,
      isNews: true, //
      isLaw: true,
      isForecast: true,
      defaultPath: '../../../static/img/blank.jpg',
      bidItemArr: [
        { name: 'home', icon: 'fa fa-home fa-fw fa-2x' },
        { name: 'Announcement', icon: 'fa fa-bullhorn fa-2x' },
        { name: 'Bidding Forecast', icon: 'fa fa-file-audio-o fa-2x' },
        { name: 'Bidding News', icon: 'fa fa-newspaper-o fa-2x' },
        { name: 'Policies and Regulations', icon: 'fa fa-gavel fa-2x' }
      ],
      activeIndex: 0
    };
  },
  components: {
    bidForcast,
    bidLaw,
    bidNews,
    bidNote
    // bidLink
    // bidRecord
  },
  methods: {
    bidModuleCtl(index) {
      this.activeIndex = index;
      switch (index) {
        case 0:
          this.isNote = true;
          this.isNews = true;
          this.isLaw = true;
          this.isForecast = true;
          this.$refs.bidNote.initBidNoteData(1, 5, false);
          this.$refs.bidNews.initBidNewsData(1, 5, false);
          setTimeout(() => {
            this.$refs.bidCast.initBidCastData(1, 5, false);
          }, 10);
          this.$refs.bidLaw.initLawData(1, 5, false);
          break;
        case 1:
          this.isNote = true;
          this.isForecast = false;
          this.isNews = false;
          this.isLaw = false;
          this.$refs.bidNote.initBidNoteData(1, 10, true);
          break;
        case 2:
          this.isForecast = true;
          this.isNote = false;
          this.isNews = false;
          this.isLaw = false;
          setTimeout(() => {
            this.$refs.bidCast.initBidCastData(1, 10, true);
          }, 10);
          break;
        case 3:
          this.isNews = true;
          this.isNote = false;
          this.isLaw = false;
          this.$refs.bidNews.initBidNewsData(1, 10, true);
          break;
        case 4:
          this.isLaw = true;
          this.isNote = false;
          this.isNews = false;
          this.isForecast = false;
          this.$refs.bidLaw.initLawData(1, 10, true);
          break;
      }
    },
    sendBack(val) {
      switch (val) {
        case 1:
          this.isNote = true;
          // this.isRecord = false;
          this.isNews = false;
          this.isLaw = false;
          this.isForecast = false;
          break;
        case 2:
          this.isForecast = true;
          this.isNote = false;
          // this.isRecord = false;
          this.isNews = false;
          this.isLaw = false;
          break;
        case 3:
          this.isNews = true;
          this.isNote = false;
          // this.isRecord = false;
          this.isLaw = false;
          this.isForecast = false;
          break;
        case 4:
          // this.isRecord = true;
          this.isNews = false;
          this.isNote = false;
          this.isLaw = false;
          this.isForecast = false;
          break;
        case 5:
          this.isLaw = true;
          // this.isRecord = false;
          this.isNews = false;
          this.isNote = false;
          this.isForecast = false;
          break;
      }
    }
  }
};
</script>
<style lang="stylus" scoped>
.bidding_module {
  width: 100%;
  background-color: #F8F8F8;
}

.bidding_body {
  width: 100%;
  min-height: 500px;
  padding: 20px 0;

  .bidding_item {
    width: 70%;
    margin: 0 auto;
    min-height: 500px;

    .bid_son_items {
      background-color: #F8F8F8;

      .bid_son_item {
        height: 60px;
        line-height: 60px;
        border: 1px solid #DCDFE6;
        text-align: center;
        padding-top: 8px;
        margin-bottom: 10px;
        background-color: #fff;
      }

      .bid_son_item:hover {
        cursor: pointer;
        background-color: #F2F6FC;
      }
    }

    .bid_space {
      margin-bottom: 20px;
    }
  }
}

img {
  vertical-align: middle;
}

.activeType {
  color: #fff;
  background-image: url('../../../../static/img/companyinfors/abu-bak.png');
  border: 1px solid #00546D;
}

.en_coin {
  color: #02566F;
}
</style>



// WEBPACK FOOTER //
// src/pages/enViews/bidding/bidding.vue